import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ImageModule } from '@df/module-image/image.module';
import { HistoryOrderItem } from '@df/session/api/history/history-order-item';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../../../../catalog/product/product.decorator';
@Component({
    selector: 'account-order-view-item',
    templateUrl: './account-order-view-item.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, PriceComponent, HrefComponent, OptionLabelPipe, ImageModule, CommonModule, RouterLink]
})
export class AccountOrderViewItemComponent extends UiComponent implements OnChanges {
    @Input()
    orderItem?: HistoryOrderItem;
    product?: Product;
    override ngOnChanges(): void {
        this.product = this.orderItem?.product as Product;
    }
}
